import { addRowsToTable } from 'gql/mutations'
import { getMultipleItemDetailsById } from 'gql/query'

export const storeCopyOfQuestions = async (paperDetails: any, questionAnswerDetail: any, userId: any) => {
  try {
    if (paperDetails && questionAnswerDetail.length > 0) {
      const batchSize = 4
      //creating batchs
      const questionAnswerBatches = Array.from({ length: Math.ceil(questionAnswerDetail.length / batchSize) }, (_, i) =>
        questionAnswerDetail.slice(i * batchSize, (i + 1) * batchSize)
      )
      for (const batchQuestions of questionAnswerBatches) {
        const batchQuestionIds = batchQuestions.map((question: any) => question.id)
        //fetching question details
        const getBatchQuestionDetails = await getMultipleItemDetailsById(
          'questions',
          batchQuestionIds,
          'id',
          `id question_id question_type_id title option_details`
        )

        if (getBatchQuestionDetails?.length !== batchQuestions?.length) {
          break
        }
        //Creating values to add
        const questionDetailsToBeAdd = getBatchQuestionDetails.map((ques: any) => {
          return {
            original_question_id: ques?.question_id,
            original_question_uuid: ques?.id,
            question_id: `${ques?.question_id}_${paperDetails?.paper_id}`,
            paper_id: paperDetails?.id,
            question_type_id: ques?.question_type_id,
            title: ques?.title,
            option_details: ques?.option_details,
            created_by: userId,
          }
        })
        //Checking values are already present or not
        const forCheckingQuestionsIds = questionDetailsToBeAdd.map((item: any) => item.question_id)
        const alreadyAddedOrNot = await getMultipleItemDetailsById('paper_question_snapshots', forCheckingQuestionsIds, 'question_id', `id`, 'String')
        //if it already added then skipping
        if (!alreadyAddedOrNot || alreadyAddedOrNot.length !== 0) {
          break
        }
        //Adding to DB;
        await addRowsToTable('paper_question_snapshots', questionDetailsToBeAdd)
      }
      return true
    }
    return false
  } catch (err) {
    console.log(err)
    return false
  }
}
